import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/image/mcxwhitelogo.png";
import { colors } from "../../utils/Colors/Colors";
import SideDrawer from "./Drawer";
import MenuList from "./Menu";
import { ResponsiveStyles, ScreenDimension } from "./responsiveDimension";
import WrapperContainer from "./WrapperContainer";
import { RoutesPath } from "../../routes/RoutesPath";
import { Link as ScrollLink } from "react-scroll";

const Navbar = () => {
  const { MD } = ScreenDimension();
  const [anchorEl, setAnchorEl] = useState(null);
  const [lastY, setLastY] = useState(null);
  const navigation = useNavigate();
  const [popOverOpen, setPopOverOpen] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation().pathname;
  const theme = useTheme();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const list = [
    {
      name: "Home",
      navigate: "home",
      // menu: [
      //   { title: "StockViewPoint", navigation: RoutesPath.HOME },
      //   { title: "Commodity", navigation: RoutesPath.COMMODITY },
      // ],
    },
    {
      name: "Features",
      navigate: "feature",
      // menu: [
      //   {
      //     title: "Data Engineering",
      //     navigation: "/dataengineer",
      //   },
      //   {
      //     title: "AI Engineering",
      //     navigation: "/aiservice",
      //   },
      //   {
      //     title: "App Development",
      //     navigation: "/mobileappservice",
      //   },
      //   {
      //     title: "UI/UX Design",
      //     navigation: "/uiuxservice",
      //   },
      //   {
      //     title: "Website Development",
      //     navigation: "/websiteappservice",
      //   },
      //   {
      //     title: "Digital Marketing",
      //     navigation: null,
      //   },
      //   {
      //     title: "Data Analytics",
      //     navigation: "/dataanalytics",
      //   },
      //   {
      //     title: "Data Entry",
      //     navigation: "/dataentry",
      //   },
      // ],
    },
    {
      name: "Pricing",
      navigate: "plans",
      // navigate: "/",
      // menu: [
      //   {
      //     title: "CareZhen",
      //     navigation: "/carzhen",
      //   },
      //   {
      //     title: "Zhepher",
      //     navigation: "/zepher",
      //   },
      //   {
      //     title: "Trackgle",
      //     navigation: "/trackgle",
      //   },
      //   {
      //     title: "Intellivuz",
      //     navigation: "/intellivuz",
      //   },
      // ],
    },
    { name: "FAQ", navigate: "faq", menu: [] },
    { name: "Contact", navigate: "contact", menu: [] },
  ];

  const handleMouseOver = (event, value) => {
    if (!Boolean(value?.menu?.length)) return;
    setPopOverOpen(value?.menu);
    const mouseY = event.clientY;
    setLastY(mouseY);
    setAnchorEl(event.currentTarget);
  };
  const handleMouseLeave = (event) => {
    const mouseY = event.clientY;
    if (mouseY <= lastY) {
      setAnchorEl(null);
    }
  };

  // const handleSelectMenu = (value) => {
  //   if (!value?.navigation || location === value?.navigation) return;
  //   navigation(value?.navigation);
  //   setAnchorEl(null);
  // };

  const handleSelectMenu = (value) => {
    if (!value?.navigation) return;
    if (value.navigate === "home") {
      // Scroll to the Plans section
      document.getElementById("home").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (value.navigate === "plans") {
      // Scroll to the Plans section
      document.getElementById("plans").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (value.navigate === "feature") {
      // Scroll to the Plans section
      document.getElementById("feature").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (value.navigate === "faq") {
      // Scroll to the Plans section
      document.getElementById("faq").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (value.navigate === "contact") {
      // Scroll to the Plans section
      document.getElementById("contact").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (value?.navigation && location !== value?.navigation) {
      navigation(value?.navigation);
    }
  };
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Fragment>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: "background.primary",
          boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <WrapperContainer> */}
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <ImageContainer onClick={() => navigation("/", { replace: true })}>
            <Image src={Logo} alt="logo" isMdup={isMdUp} />
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: theme.palette.text.tertiary,
              }}
            >
              {/* Logo */}
            </Typography>
          </ImageContainer>
          {MD ? (
            <MenuItem>
              {list.map((value, index) => (
                <MenuText
                  component={location === "/" ? ScrollLink : Link}
                  to={location === "/" ? value.navigate : "/"}
                  key={index}
                  onMouseMove={(e) => handleMouseOver(e, value)}
                  onMouseLeave={handleMouseLeave}
                  smooth={value.navigate === "plans"}
                  offset={-70}
                >
                  {value.name}
                </MenuText>
              ))}
            </MenuItem>
          ) : (
            <Stack onClick={handleDrawerToggle}>
              <MenuOutlinedIcon />
            </Stack>
          )}
        </Toolbar>
        {/* </WrapperContainer> */}
      </AppBar>
      <SideDrawer open={mobileOpen} handleClose={handleDrawerToggle} />

      {Boolean(anchorEl) && (
        <MenuList
          list={popOverOpen}
          displayKey="title"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          handleClose={() => setAnchorEl(null)}
          handleSelect={handleSelectMenu}
        />
      )}
    </Fragment>
  );
};

export default Navbar;
const Image = styled("img")(({ theme, isMdup }) => ({
  width: isMdup ? "15%" : "25%",
}));
const ImageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  gap: 6,
  padding: "5px",
  ...ResponsiveStyles({
    // width: { xs: "30%", md: "15%" },
  }),
}));
const MenuItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  ...ResponsiveStyles({
    width: { xs: "20%", md: "35%" },
    justifyContent: {
      xs: "end",
      md: "space-between",
    },
  }),
}));
const MenuText = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  color: theme.palette.text.secondary,
  textDecoration: "none",
  transition: "all 0.3s linear",
  fontWeight: 600,
  position: "relative",
  zIndex: 2,
  cursor: "pointer",
  ":hover": {
    transition: "all 0.3s linear",
    color: "rgba(232, 177, 0, 1)",
  },
  ":hover::before": {
    transition: "all 0.2s linear",
    width: "100%",
  },
  "::before": {
    position: "absolute",
    transition: "all 0.3s linear",
    content: '" "',
    height: 2,
    borderRadius: 5,
    width: "0%",
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(232, 177, 0, 1)",
  },
}));
const MenuIcon = styled(Box)(({ theme }) => ({
  color: "#384bff",
  cursor: "pointer",
  fontSize: 30,
}));
